import { createAction, EmptyActionCreator } from 'redux-act';

const MODULE_ID = 'FD_CONFIG_PAYMENT_';

const createPaymentAction = <T>(type: string) => createAction<T>(`${MODULE_ID}${type}`);

export const setState = createPaymentAction<WebOrder.State.Payments>('SET_STATE');

export const setStatus = createPaymentAction<{
  status: WebOrder.State.Payments['status'];
  error?: Error;
}>('SET_STATUS');

export const setPayment = createPaymentAction<WebOrder.State.Payment>('SET_ITEM');
export const updatePayment = createPaymentAction<
  Partial<WebOrder.State.Payment> & { paymentId: string }
>('UPDATE_ITEMS');

//#region just events
export type CreditCardPaymentAddedProps = {
  paymentAccountId: number;
  cardNumber: string;
};
export const creditCardPaymentAdded = createPaymentAction<CreditCardPaymentAddedProps>(
  'CREDIT_CARD_ADDED'
);

export const paymentRemoved = createPaymentAction<{
  paymentId: string;
}>('PAYMENT_REMOVED');

export const setDefaultSelected = createPaymentAction<{
  paymentId: string;
}>('SET_DEFAULT');

/** (TEMPORARY) one way bridge from old actions and new sagas world */

export const cancelAddBridge = createPaymentAction('CANCEL_ADD_BRIDGE') as EmptyActionCreator;

//#endregion
